import { type SelectOption } from "@/shared/components/forms/ColocaSelectField";
import type { CountryLabelResolver } from "@/shared/hooks/useCountryLabel";

import { SUPPORTED_COUNTRY_OPTIONS } from "../../constants/clients.constants";

/**
 * Country selector items restricted to the six backend-supported ISO3 codes (`@IsCountryCode`). Used for
 * `identity.country`, `nationality` and `owner_country_code` — all validated against the same six codes.
 *
 * Takes the label resolver from `useCountryLabel` so the name follows the locale while the option value stays
 * the ISO3 code the API expects.
 */
export const countryItems = (labelFor: CountryLabelResolver): SelectOption[] =>
  SUPPORTED_COUNTRY_OPTIONS.map((option) => ({
    value: option.value,
    label: labelFor(option.value, option.label),
  }));

/** Backend `@IsInternationalPhone` rejects non-digits; strip everything but digits (no + prefix). */
export const normalizePhone = (raw: string): string => raw.replace(/\D/g, "");

/**
 * Exact mirror of the backend `@Matches` pattern on `first_name`, `last_name` and `owner_name`
 * (IndividualIdentityDto / BusinessIdentityDto): letters with Spanish accents, spaces, hyphens and
 * apostrophes.
 */
export const PERSON_NAME_REGEX = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s'-]+$/;
